import { render } from "./SectionRegister.vue?vue&type=template&id=47c3f08c&scoped=true"
import script from "./SectionRegister.vue?vue&type=script&lang=js"
export * from "./SectionRegister.vue?vue&type=script&lang=js"

import "./SectionRegister.vue?vue&type=style&index=0&id=47c3f08c&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c3f08c"]])

export default __exports__